var _style, _defs, _defs2, _defs3, _defs4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckTertiary = function SvgCheckTertiary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checkTertiary_svg__Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 26 24",
    style: {
      enableBackground: "new 0 0 26 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".checkTertiary_svg__st0{clip-path:url(#checkTertiary_svg__SVGID_00000005984800819294351290000004471381130973541261_)}.checkTertiary_svg__st1{clip-path:url(#checkTertiary_svg__SVGID_00000126294251964127346520000008192811391352551605_)}.checkTertiary_svg__st2{clip-path:url(#checkTertiary_svg__SVGID_00000138551630551528101860000009467656316474299804_)}.checkTertiary_svg__st4{clip-path:url(#checkTertiary_svg__SVGID_00000179630515466576135190000009080138787580625833_)}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "checkTertiary_svg__SVGID_1_",
    d: "M0 0h26v24H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "checkTertiary_svg__SVGID_00000050657134212719058610000013679463841892732046_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#checkTertiary_svg__SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#checkTertiary_svg__SVGID_00000050657134212719058610000013679463841892732046_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "checkTertiary_svg__SVGID_00000086663160199789953340000014599258164015708823_",
    transform: "rotate(-60.988 11.484 11.541)",
    d: "M-.9-.5h24.8v24H-.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "checkTertiary_svg__SVGID_00000031175224763414555250000007392848563566140814_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#checkTertiary_svg__SVGID_00000086663160199789953340000014599258164015708823_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#checkTertiary_svg__SVGID_00000031175224763414555250000007392848563566140814_)"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "checkTertiary_svg__SVGID_00000114794017831935563570000017191136900827260854_",
    transform: "rotate(-60.988 11.484 11.541)",
    d: "M-.9-.5h24.8v24H-.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "checkTertiary_svg__SVGID_00000147926781611598500030000000292160774854930324_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#checkTertiary_svg__SVGID_00000114794017831935563570000017191136900827260854_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#checkTertiary_svg__SVGID_00000147926781611598500030000000292160774854930324_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 6.4C.2 8.8.4 11.3.8 13.8c.4 2.2 1.1 4.3 2.4 6.1.6.9 1.4 1.8 2.3 2.4.9.6 2 .9 3 1 1.1.1 2.2 0 3.2-.4 1.1-.5 2.1-1.2 3-2 2.1-1.7 4.6-3 6.8-4.7 1.9-1.5 3.6-3.6 3.9-6.1.3-2.4-.9-4.5-2.7-6-2.1-1.7-4.7-2.6-7.4-2.9-1.3-.2-2.7-.2-4-.2-1.3 0-2.7.1-4 .2-1.3.1-2.4.4-3.4 1.1C3 3 2.2 3.8 1.6 4.8c-.2.5-.5 1.1-.6 1.6",
    style: {
      fill: "#ecf2fe"
    }
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "checkTertiary_svg__SVGID_00000123406594469153717970000010913411708384939177_",
    d: "M2.8 2h22.5v18H2.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "checkTertiary_svg__SVGID_00000001629434988541636460000005421206257959684505_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#checkTertiary_svg__SVGID_00000123406594469153717970000010913411708384939177_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#checkTertiary_svg__SVGID_00000001629434988541636460000005421206257959684505_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8 11.2c.1-.3.2-.6.5-.8.5-.4 1.1-.4 1.6-.1.9.5 1.7 1.2 2.4 1.9.9.9 1.6 1.9 2.3 2.9 0 .1.1.1.1.1l.9-1.8c1.9-3.4 4.4-6.3 7.6-8.5 1.5-1.1 3.2-1.9 5-2.6 1-.4 2 .3 2 1.2v.1c0 .1 0 .2-.1.3-.1.5-.4.9-.9 1-1.6.6-3.1 1.3-4.5 2.3-2.3 1.7-4.2 3.8-5.8 6.2-1.1 1.7-2 3.5-2.7 5.4-.2.5-.5.8-1.1.9h-.4c-.5-.1-.9-.4-1.1-.8-.8-1.5-1.6-2.9-2.7-4.1-.7-.8-1.4-1.6-2.3-2.1-.5-.3-.8-.6-1-1.1.2-.1.2-.2.2-.4z",
    style: {
      fill: "#004aad"
    }
  })));
};
export default SvgCheckTertiary;